import PetsIcon from "@mui/icons-material/Pets";
import React from "react";
import { colorTheme } from "../../utils/SOCUtils";
type Props = {
    style?: React.CSSProperties;
    background?: string;
    color?: string;
    sx?: React.CSSProperties;
    type?: keyof typeof colorTheme;
}

const SocStatusCustomIcon = (props: Props) => {
  const { sx, type = "default" } = props;
  const { bgColor, color } = colorTheme[type] || colorTheme["default"];

  return (
    <PetsIcon sx={{ ...sx, borderRadius: "0.75rem", p: "1.5px", fontSize: "1rem",
      background: color, color: `${bgColor} !important` }}/>
  );
};

export default SocStatusCustomIcon;
